module.exports = __webpack_public_path__ + "img/android-chrome-512x512-2.d8203662.png";